export default __webpack_public_path__ + "static/media/No48Closed.9d3cc9fa.jpg";